// extracted by mini-css-extract-plugin
export default {"page_wrapper":"center-page_page_wrapper__gPWVv","content_wrapper":"center-page_content_wrapper__BQonx","logo_wrapper":"center-page_logo_wrapper__mFiuU"};